import { render } from "./Main_coop.vue?vue&type=template&id=c3d43ef2"
import script from "./Main_coop.vue?vue&type=script&lang=js"
export * from "./Main_coop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__